import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';

import {
  FormWrapper,
  FormWrapperDiv,
  FormField,
  InputWrapper,
} from 'libs/forms/styles';
import FormActionButton from 'libs/forms/views/formActionButton';
import { SelectField } from 'libs/forms/views/fieldTypes/select';
import { Code } from 'libs/editor/styles';

import { Center } from 'legacyComponents/styled/lib';
import { Date } from 'apps/components/date';
import { Button } from 'components';
import { Dropdown } from 'apps/autocomplete/views/dropdown';
import { SectionTitle } from 'apps/group/styles';

export const LinkSection = observer(({ app, type }) => {
  let form;
  if (app && !app.url) {
    const { linkForm, CreateLink } = app;
    const expiresInField = linkForm.fieldStores.get('expiresInDays');
    const refs = {};
    form = (
      <FormWrapper
        responsive
        posting=''
        onSubmit={e => {
          e.preventDefault();
          linkForm.prepare();
          CreateLink();
        }}
      >
        <FormField>
          <Msg>
            <Trans>
              Invite anyone instantly, with a link to join this {type}.
            </Trans>
          </Msg>

          <SelectField
            fieldStore={expiresInField}
            ref={input => {
              refs[expiresInField.fieldName] = input;
            }}
            responsive
            noValidation
          />
          <Dropdown
            inputFields={refs}
            fieldName={expiresInField.fieldName}
            manager={expiresInField.optionsManager}
          />
        </FormField>

        <Center>
          <FormActionButton
            formStore={linkForm}
            buttonText={linkForm.conf.buttonText}
            buttonTextPosting={linkForm.conf.buttonTextPosting}
            // FIXME: remove this inline style
            style={{ marginTop: '1rem' }}
          />
        </Center>
      </FormWrapper>
    );
  } else if (app) {
    const { url, expiresAt, CopyLinkToClipboard, DeleteLink } = app;
    form = (
      <FormWrapperDiv responsive>
        <Msg>
          <Trans>
            Invite anyone instantly, with this link to join this {type}.
          </Trans>
        </Msg>
        <InputWrapper responsive>
          <Code>{url}</Code>
        </InputWrapper>
        {expiresAt && (
          <Expires>
            <strong>
              <Trans>
                Expires <Date value={expiresAt} />
              </Trans>
            </strong>
            &nbsp;|&nbsp;
          </Expires>
        )}
        <Expires>
          <Trans>
            Need to change this? Deactivate your link and choose a new duration
            |&nbsp;
          </Trans>
        </Expires>
        <DeActivate onClick={DeleteLink}>Deactivate link</DeActivate>
        <Center>
          <Button
            text={<Trans>Copy Link</Trans>}
            onClick={() => CopyLinkToClipboard()}
            size='small'
          />
        </Center>
      </FormWrapperDiv>
    );
  }
  return (
    <Main>
      <SectionTitle level={2} size='medium'>
        <Trans>Get a Magic Link</Trans>:
      </SectionTitle>
      {form}
    </Main>
  );
});

const Main = styled.div`
  position: relative;
`;

const Msg = styled.p`
  margin: 0 0 ${props => props.theme.spacing.default};
`;

const Expires = styled.p`
  font-size: ${props => props.theme.font.size.small};
  margin-top: ${props => props.theme.spacing.small};
  display: inline-block;
`;

const DeActivate = styled(Expires)`
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;
  margin-bottom: ${props => props.theme.spacing.default};
  color: ${props => props.theme.color.wfOrange};
`;
